export const getISOWeekNumber = (date = new Date()) => {
  // Copy date so we don't mutate the original object
  const target = new Date(date.valueOf());

  // ISO weeks start on Thursday in the current week to decide the year
  const dayNr = (date.getDay() + 6) % 7;
  target.setDate(target.getDate() - dayNr + 3);

  // January 4th is always in Week 1
  const firstThursday = target.valueOf();
  target.setMonth(0, 4);

  const dayOct = (target.getDay() + 6) % 7;
  target.setDate(target.getDate() - dayOct + 3);

  // Calculate full weeks between the two Thursdays
  const weekNumber =
    1 + Math.round((firstThursday - target.valueOf()) / 604800000);
  return weekNumber;
};
